export const resolveRecommendation = _ref => {
  let {
    data,
    recommendedProductName,
    t
  } = _ref;
  if (!data) {
    return null;
  }
  const isFallback = data.isFallback;
  if (isFallback) {
    const subtitleDefault = recommendedProductName ? `${recommendedProductName} gives you the tools to grow your business online` : 'The tools to grow your business online';
    return {
      subtitle: t(data.subtitle, {
        planName: recommendedProductName,
        defaultValue: subtitleDefault
      }),
      bullets: data.bullets.map((key, i) => t(key, {
        planName: recommendedProductName,
        defaultValue: ['More storage and team members as your business grows', 'Marketing and eCommerce tools to reach more customers', 'Business tools and integrations to help you do more'][i] ?? ''
      })),
      recommendedProductId: data.recommendedProductId
    };
  }
  return {
    subtitle: data.subtitle,
    bullets: data.bullets,
    recommendedProductId: data.recommendedProductId
  };
};
//# sourceMappingURL=resolveRecommendation.js.map